import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FnPaginationComponent } from './fn-pagination.component';

export * from './fn-pagination.component';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [FnPaginationComponent],
    exports: [FnPaginationComponent]
})
export class FnPaginationModule {

}
